export default __webpack_public_path__ + "static/media/spotGuideButton.80f09a6f.svg";